module.exports = __webpack_public_path__ + "iconfont.9bd1af8a6ed6a40d4b72.ttf";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/iconfont/projectIconfont/iconfont.ttf?t=1483974170613
// module id = ../../../../../ng-src/assets/iconfont/projectIconfont/iconfont.ttf?t=1483974170613
// module chunks = styles